/* eslint-disable */
import React, { useMemo, useRef } from 'react';
import './_blog.table.scss'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { isNull, truncate } from 'lodash';
import { useHistory } from 'react-router-dom';
import FormSwitch from '../../../../../../components/FormSwitch';
import { routesAppearance } from '../../../../helpers';
import { useTbodyPosition } from '../../../../../../utils/hooks/useTbodyPosition';

const Body = ({ isLoading, items, config }) => {
  const history = useHistory();
  const routeEditPost = useMemo(() => routesAppearance.find((route) => route.code === 'edit-blog'), [])
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '300px' });
  const onEditPost = (pageId) => {
    if (pageId) {
      history.push({
        pathname: routeEditPost.link,
        search: `?id=${pageId}`,
      })
    }
  }

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: '54%' }}
      ref={bodyRef}
    >
      {items.map((post) => {
        const updatedSplit = post.created.split(' ');
        const firstDate = updatedSplit[0];
        const secondDate = updatedSplit[1];
        return (
          <tr
            key={`post-${post.id}`}
            className={classNames({
              grey: !post.visibility,
            })}
          >
            <td className="p-l blog-table__name">
              {post.title ? <span className="blog-table__post-title">
                {truncate(post.title, {
                  length: 140,
                  omission: '...',
                })}
              </span> : null}
              <a href={post.link} target="_blank" className="blog-table__link"><span className="fas fa-external-link"/></a>
            </td>
            <td className="blog-table__created">
              <span>{firstDate}</span>
              {' '}
              {secondDate ? <span>{secondDate}</span> : null }
            </td>
            <td className="blog-table__visibility">{post.public}</td>
            {config?.access?.blogs_edit
              ? (
                <td className="p-r text-right">
                  <Button onClick={() => onEditPost(post.id)} bsSize="xsmall">Edit</Button>
                </td>
              ) : null}
          </tr>
        )
      })}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
};

export default Body;
